import type { JSX } from "react";

export function IconPlaceholder(): JSX.Element {
    return <span className="icon" />;
}
